var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWordCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 18.2c.2 0 .2-.2.2-.3v-2.1l-.2-.3H6.4c-.2 0-.2.1-.2.3v2c0 .2 0 .3.2.4zm6.7 2v2.4H30V20h-4.2zm0-2h2.7v-2.7h-2.7v2.7zM4.5 9V6.8H1.6v2.7h2.9zm21.3 2v2.7H30V11zM4.5 13.4V11H.2v2.7h4.3zm6.5.3h8.3l.1-.3v-2l-.1-.4H11l-.2.3v2c0 .3 0 .4.2.4zm-2.2 0l.3-.1V.2L8.8 0H6.7c-.2 0-.3 0-.3.2v13.4l.3.1zm12.7-2.9c-.1 0-.3 0-.3.2v15.3c0 .2.2.2.3.2h2.1c.2 0 .3 0 .3-.2V11l-.3-.2zM.3 19.9h19c.2 0 .3.1.3.3v2.1c0 .2-.1.3-.3.3H.3a.3.3 0 01-.3-.3v-2.1c0-.2.1-.3.3-.3zM11.1 6.4h16.8c.2 0 .3.1.3.3v2.1c0 .2-.1.3-.3.3H11.1a.3.3 0 01-.3-.3V6.7c0-.2.1-.3.3-.3zM11 4.6h9.7c.2 0 .2-.1.2-.3v-2c0-.2 0-.4-.2-.4H11c-.2 0-.2.2-.2.3v2.1c0 .2 0 .3.2.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordCloud);
export default __webpack_public_path__ + "static/media/word-cloud.bccbefac.svg";
export { ForwardRef as ReactComponent };